import type {
  ChangePasswordPayload,
  CreateStripeTokenPayload,
  CreateStripeTokenResponse,
  LoginPayload,
  LoginResponse,
  PatchProfilePayload,
  PaymentInfoResponse,
  Profile,
  RegisterPayload,
  RegistrationResponse,
  ResetPasswordConfirmPayload,
} from "../types/accounts";
import { apiService } from "./apiService";
import { getErrorMessage } from "./errorHandling";

export { refreshAccessToken } from "./apiService";

export const registerUser = async (data: RegisterPayload) => {
  try {
    return await apiService<RegistrationResponse>({ method: "post", url: "/accounts/register/", data });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const login = async (data: LoginPayload) => {
  try {
    return await apiService<LoginResponse>({ url: "/accounts/login/", method: "post", data });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const resetPassword = async (data: { email: string }) => {
  try {
    return await apiService({ method: "post", url: "/accounts/reset-password/", data });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const resetPasswordConfirm = async (data: ResetPasswordConfirmPayload) => {
  try {
    return apiService<LoginResponse>({ method: "post", url: "/accounts/reset-password-confirm/", data });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const fetchProfile = async () => {
  try {
    return await apiService<Profile>({ method: "get", url: "/accounts/profile/" });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const patchProfile = async ({
  data,
  isMultipart,
}: {
  data: PatchProfilePayload | FormData;
  isMultipart?: boolean;
}) => {
  try {
    return await apiService<Profile>({ method: "patch", url: "/accounts/profile/", data, isMultipart });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const changePassword = async (data: ChangePasswordPayload) => {
  try {
    return await apiService({ method: "patch", url: "/accounts/change-password/", data });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const getPaymentInfo = async () => {
  try {
    return await apiService<PaymentInfoResponse>({ method: "get", url: "/accounts/stripe/create-checkout-session/" });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const createStripeFlowToken = async (data: CreateStripeTokenPayload) => {
  try {
    return await apiService<CreateStripeTokenResponse>({
      method: "post",
      url: "/accounts/stripe/create-checkout-session/",
      data,
    });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const payWithLink = async (data: CreateStripeTokenPayload) => {
  try {
    return await apiService<{ url: string }>({
      method: "post",
      url: "/accounts/stripe/card-checkout-session/",
      data,
    });
  } catch (error) {
    throw getErrorMessage(error);
  }
};
